import React from 'react';

const ClientTestimonials: React.FC = () => {
  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      position: "Project Manager",
      company: "Reliance Industries",
      industry: "Oil & Gas",
      image: "/client1.jpg",
      rating: 5,
      testimonial: "AVIS has been our trusted NDT partner for over 5 years. Their expertise in ultrasonic testing and attention to detail has helped us maintain the highest safety standards in our refinery operations."
    },
    {
      id: 2,
      name: "Priya Sharma",
      position: "Quality Assurance Head",
      company: "Tata Power",
      industry: "Power Generation",
      image: "/client2.jpg",
      rating: 5,
      testimonial: "The team at AVIS consistently delivers accurate and reliable results. Their advanced equipment and certified technicians give us confidence in our critical infrastructure testing."
    },
    {
      id: 3,
      name: "Amit Patel",
      position: "Engineering Director",
      company: "Mahindra & Mahindra",
      industry: "Automotive",
      image: "/client3.jpg",
      rating: 5,
      testimonial: "We've been working with AVIS for our automotive component testing needs. Their fast turnaround times and comprehensive reporting have significantly improved our quality control processes."
    },
    {
      id: 4,
      name: "Dr. Sunita Reddy",
      position: "Chief Engineer",
      company: "BHEL",
      industry: "Power Generation",
      image: "/client4.jpg",
      rating: 5,
      testimonial: "AVI'S expertise in radiographic testing and their ability to handle complex projects has been instrumental in our power plant maintenance programs. Highly recommended!"
    },
    {
      id: 5,
      name: "Vikram Singh",
      position: "Operations Manager",
      company: "ONGC",
      industry: "Oil & Gas",
      image: "/client5.jpg",
      rating: 5,
      testimonial: "The professionalism and technical competence of the AVIS team is outstanding. They've helped us identify potential issues before they become critical problems."
    },
    {
      id: 6,
      name: "Meera Joshi",
      position: "Safety Officer",
      company: "Larsen & Toubro",
      industry: "Construction",
      image: "/client6.jpg",
      rating: 5,
      testimonial: "AVI'S comprehensive NDT services have been crucial for our infrastructure projects. Their detailed reports and recommendations have helped us maintain the highest safety standards."
    }
  ];

  const stats = [
    { number: "98%", label: "Client Satisfaction Rate" },
    { number: "500+", label: "Projects Completed" },
    { number: "100+", label: "Happy Clients" },
    { number: "8+", label: "Years of Experience" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-avis-blue to-avis-dark text-white py-20">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">Client Testimonials</h1>
            <p className="text-xl lg:text-2xl text-blue-100 max-w-3xl mx-auto">
              What our clients say about our services
            </p>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Success Metrics</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Numbers that reflect our commitment to excellence
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-avis-blue mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Real feedback from our valued clients across various industries
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = '/assets/logo.png';
                    }}
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                    <p className="text-sm text-gray-600">{testimonial.position}</p>
                    <p className="text-sm text-avis-blue">{testimonial.company}</p>
                  </div>
                </div>
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 italic mb-4">"{testimonial.testimonial}"</p>
                <div className="text-sm text-gray-500">
                  <span className="font-medium">{testimonial.industry}</span> Industry
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Recognition */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Industry Recognition</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Trusted by leading companies across diverse sectors
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-avis-blue rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Fortune 500 Companies</h3>
              <p className="text-gray-600">Trusted by multiple Fortune 500 companies for critical NDT services</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-avis-blue rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Government Projects</h3>
              <p className="text-gray-600">Approved vendor for various government and PSU projects</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-avis-blue rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Long-term Partnerships</h3>
              <p className="text-gray-600">Many clients have been with us for over 10+ years</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-avis-blue text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Experience the AVIS Difference</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Join our satisfied clients and discover why we're the preferred NDT service provider
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/quotation"
              className="bg-white text-avis-blue px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors duration-200"
            >
              Get Your Quote
            </a>
            <a
              href="/clients"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-avis-blue transition-colors duration-200"
            >
              View Our Clients
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClientTestimonials;
